
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sourcing/browse/[category]/suppliers",
      function () {
        return require("private-next-pages/sourcing/browse/[category]/suppliers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sourcing/browse/[category]/suppliers"])
      });
    }
  